import { ResultPostContent } from "./Results/ResultPostContent";
import { ResultsEmpty } from "./Results/ResultsEmpty";
import PostCategories from "./Results/PostCategories";
import PostDataNumber from "./Results/PostDataNumber";
import ResultsLoading from "./Results/ResultsLoading";
import { useRouter } from "next/router";
import Link from "next/link";
import { ISSUES_TYPE } from "~/types";
import { type FC } from "react";
import { type ElasticSearchPostResult } from "~/utils/elasticSearchUtils";

type ResultsProps = {
  posts: ElasticSearchPostResult["hits"]["hits"];
  totalResults: number;
  loading: boolean;
};

const Results: FC<ResultsProps> = ({ posts, totalResults, loading }) => {
  const router = useRouter();

  if (loading) return <ResultsLoading />;
  if (totalResults == 0) return <ResultsEmpty />;

  return (
    <div className="mx-auto mt-8 w-full max-w-box">
      {posts.map((post) => {
        const isFree = post?._source?.meta?._no_login_field?.find((element) =>
          Boolean(element?.value)
        );
        const hasVideo = post?._source?.meta?.video?.find((element) =>
          Boolean(element?.value)
        );

        const hasAudio = post?._source?.meta?.audio?.find((element) =>
          Boolean(element?.value)
        );

        const authors = post?._source?.meta?.autore?.filter((element) =>
          Boolean(element?.value)
        );

        return (
          <>
            <div className="mr-auto mt-6 w-full">
              {post?._source?.terms?.[ISSUES_TYPE.numbers] && (
                <PostDataNumber
                  issuem_issue={post?._source?.terms?.[ISSUES_TYPE.numbers][0]}
                  data_post={post?._source?.post_date}
                />
              )}
              <h3 className="mb-6">
                <Link
                  className="text-2xl font-light text-black hover:underline hover:opacity-80 sm:text-4xl md:text-2xl lg:text-4xl"
                  href={{
                    pathname: "/a/[slug]",
                    query: {
                      slug: post?._source?.post_name,
                      q: router.query.q,
                      fields: router.query.fields,
                      searchType: router.query.searchType,
                    },
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      post.highlight?.post_title?.join() ||
                      post.highlight?.["post_title.exact"]?.join() ||
                      post._source?.post_title,
                  }}
                />
              </h3>
              <div className="flex flex-row ">
                {isFree && (
                  <span className=" mb-4 mr-2 inline-block rounded-lg bg-orange px-2 py-1 text-xs text-white ">
                    FREE
                  </span>
                )}
                {hasVideo && (
                  <span className=" mb-4 mr-2 inline-block rounded-lg bg-gray px-2 py-1 text-xs text-white">
                    VIDEO
                  </span>
                )}
                {hasAudio && (
                  <span className=" mb-4 mr-2 inline-block rounded-lg bg-gray px-2 py-1 text-xs text-white">
                    AUDIO
                  </span>
                )}
              </div>
              <ResultPostContent article={post} />
              <div className="mt-5 flex flex-col pb-4 md:flex-row md:items-center">
                {authors?.map(({ value }) => (
                  <p
                    key={value}
                    className="mr-4 rounded-xl border border-brown px-2 py-1 text-center text-sm uppercase text-brown md:text-left lg:px-4"
                  >
                    {value.split(",")[0]}
                  </p>
                ))}
                {post?._source?.terms?.[ISSUES_TYPE.categories] && (
                  <PostCategories
                    categories={post?._source?.terms?.[ISSUES_TYPE.categories]}
                    typeCategories={ISSUES_TYPE.categories}
                  />
                )}
                {post?._source?.terms?.[ISSUES_TYPE.multimedia] && (
                  <PostCategories
                    categories={post?._source?.terms?.[ISSUES_TYPE.multimedia]}
                    typeCategories={ISSUES_TYPE.multimedia}
                  />
                )}
                {post?._source?.terms?.[ISSUES_TYPE.speciali] && (
                  <PostCategories
                    categories={post?._source?.terms?.[ISSUES_TYPE.speciali]}
                    typeCategories={ISSUES_TYPE.speciali}
                  />
                )}
              </div>
            </div>
            <div className="mb-14 border-b border-gray pb-12"></div>
          </>
        );
      })}
    </div>
  );
};

export default Results;
